var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<span ng-if=\"$ctrl.isSingle()\">{{ 'services.select_one' | i18next }}</span>\n<span ng-if=\"!$ctrl.isSingle() && ($ctrl.min || $ctrl.max)\"> {{ 'services.select' | i18next }}\n<span ng-if=\"$ctrl.min\" ng-class=\"$ctrl.minClasses()\">{{ 'services.select_min' | i18next: {num: $ctrl.min} }}</span>\n<span ng-if=\"$ctrl.min && $ctrl.max\">{{ 'services.select_and' | i18next }}</span>\n<span ng-if=\"$ctrl.max\" ng-class=\"$ctrl.maxClasses()\">{{ 'services.select_max' | i18next: {num: $ctrl.max} }}</span>\n{{ 'services.select_type' | i18next }} </span>\n<span ng-if=\"$ctrl.min && $ctrl.totalAmount !== undefined\">{{ 'services.selected' | i18next: {num: $ctrl.totalAmount} }}</span>\n<span ng-if=\"$ctrl.min && $ctrl.isValid()\" class=\"text-success\">{{ 'services.select_ready' | i18next }}</span>";
var id1="winresServiceReq.html";
ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/components/winresServiceReq/winresServiceReq.html
// module id = 454
// module chunks = 2